import { useState } from "react";
import { HtmlTooltip } from "../../../../components/miniComponents";
import CustomIcon from "../../../../components/customIcon";
import { Box } from "@mui/material";

export const TooltipComponent = ({ info, disabled }) => {
    const [open, setOpen] = useState(false);
    return (
        <HtmlTooltip
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            leaveTouchDelay={5000}
            title={
                <Box
                    sx={{
                        bgcolor: "primary.lighter",
                        borderRadius: 1,
                        padding: 2
                    }}
                >
                    {
                        info
                    }
                    {/* <Typography dangerouslySetInnerHTML={{__html: info}} variant="caption" color={"text.primary"}></Typography> */}
                </Box>
            }
        >
            <Box onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpen(true)
            }}>
                <CustomIcon name="info" sx={{ width: 12, height: 12, bgcolor: disabled ? "text.disabled" : "#000" }} />
            </Box>
        </HtmlTooltip>
    )
}